export default __webpack_public_path__ + "static/media/VW.09534465.png";